module.exports = __webpack_public_path__ + "static/LogoMain-0edac7f861ebc62fd0a2947464f20114.png";